import React, { useEffect, useState } from 'react'
import PrivacyandPolicyAPI from '../api/PrivacyAndPolicyAPI'

const PrivacyandPolicy = () => {
  const [privacyData, setPrivacyData] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await PrivacyandPolicyAPI.getPrivacyandPolicy();
        setPrivacyData(res.data);

      } catch (err) {
        console.error("Error:", err);
        setError("Unable to load data.");
      }
    }
    fetchData();
  }, [])
  return (
    <div className="custom-privacy-policy-section">
      <h3 className='text-center py-4' style={{color:"#259dd1"}}>
        Privacy & Policy
      </h3>
      <div className="container" style={{minHeight:"50vh"}}>
      <div className='policy-text' dangerouslySetInnerHTML={{ __html: privacyData.description }}>
      </div>
    </div>
    </div >
  )
}

export default PrivacyandPolicy
